/* Prime Raw — product grid tabs: switch panel and the View all link. */
if (!customElements.get('pr-tabs-products')) {
  customElements.define(
    'pr-tabs-products',
    class PrTabsProducts extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        var section = this.closest('section');
        this.allLink = section && section.querySelector('[data-pr-all]');
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { self.select(i); });
          tab.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
            self.select(next);
            self.tabs[next].focus();
          });
        });
      }

      select(index) {
        var self = this;
        this.tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          var panel = self.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (on && self.allLink && tab.dataset.url) self.allLink.setAttribute('href', tab.dataset.url);
        });
      }
    }
  );
}
